<template>
  <div class="view-home">
    <div class="container">
      <div class="quiz-status my-4">
        <div class="card" v-show="countdown">
          <ul>
            <li class="time">
              {{ countdown }}
            </li>
            <li class="recording" v-if="quiz.proctoring">
              {{ $t('testing.recording') }}
            </li>
            <li class="interruption" v-if="quiz.proctoring">
              {{ $t('testing.interruption') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container questions-wrap">
      <h2>
        {{ $t('creativity-15-17.title') }}
      </h2>
      <h3>
        {{ $t('creativity-15-17.subTitle2') }}
      </h3>
      <div class="collaboration-desc" v-html="$t('creativity-15-17.instruction2')">
      </div>

      <div class="d-flex flex-column" v-if="this.$i18n.locale == 'ru'">
        <div class="question-item" v-if="currentSubtest == 1">
          1. {{ $t('creativity-15-17.task1') }}
          <el-input placeholder="Запиши существительные, которые начинаются на слог «фи»" v-model="inputSubtest1"></el-input>
        </div>


        <div class="question-item" v-if="currentSubtest == 2">
          2. {{ $t('creativity-15-17.task2') }}
          <el-input placeholder="Запиши существительные, которые оканчиваются слогом «ва»" v-model="inputSubtest2"></el-input>
        </div>
      </div>
      <div class="d-flex flex-column" v-else>
        <div class="question-item" v-if="currentSubtest == 1">
          1. {{ $t('creativity-15-17.task1') }}
          <el-input placeholder="«Ба» буын сөзден басталатын зат есімдерді ойлап табыңыз және жазыңыз" v-model="inputSubtest1"></el-input>
        </div>


        <div class="question-item" v-if="currentSubtest == 2">
          2. {{ $t('creativity-15-17.task2') }}
          <el-input placeholder="«Ай» буын сөзден аяқталатын зат есімдерді ойлап табыңыз және жазыңыз" v-model="inputSubtest2"></el-input>
        </div>
      </div>


      <!--      <button @click="sendCollaborationResults">Отправить</button>-->
      <el-button @click="nextSubtest(false)"
                 class="btn btn-primary" v-if="currentSubtest == 1">
        {{ $t('creativity-15-17.next') }}
      </el-button>

      <el-button @click="openModal"
                 class="btn btn-danger" v-if="currentSubtest == 2">{{ $t('testing.finish-modal-button') }}
      </el-button>

    </div>
    <b-modal id="exit-modal" hide-footer hide-header>
      <div id="modal-wrapper">
        <div id="dialog">
          <button @click="$bvModal.hide('exit-modal')" type="button" class="close" data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
          <img class="modal-warning-img mb-3" src="/images/profile/modal-warning.svg">
          <h3 class="mb-0">{{modalTitle}}</h3>
          <p>{{ $t('testing.finish-modal-desc') }}</p>
          <div class="clearfix pt-3">
            <el-button @click="sendCreativitySubtest2Results(false)" class="btn btn-primary mx-2">
              {{ $t('testing.finish-modal-button') }}
            </el-button>
            <a @click="$bvModal.hide('exit-modal')"
               class="btn btn-outline-primary mx-2">{{ $t('testing.finish-modal-cancel') }}</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import 'katex/dist/katex.min.css';
import Loader from '../../components/Loader';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue';

Vue.use(VueViewer)
export default {
  name: "Index",
  data() {
    return {
      modalTitle: this.$t('testing.finish-modal-title'),
      timerInterval: null,
      countdown: 0,
      quiz: '',
      answersComplexExplanations: [
        { choice: "", question: "1" },
        { choice: "", question: "2" },
        { choice: "", question: "3" },
        { choice: "", question: "4" },
        { choice: "", question: "5" },
        { choice: "", question: "6" },
        { choice: "", question: "7" },
        { choice: "", question: "8" },
        { choice: "", question: "9" },
      ],
      score: null,
      keysSubtest1: [
        "фиакр", "фиал", "фиалка", "фианит", "фибра", "фибрин", "фибриноген",
        "фибринозный", "фибринолиз", "фиброз", "фигура", "фигурант", "фидуция",
        "физвоспитание", "физзарядка", "физзащита", "физиатр", "физиатрия",
        "физик", "физика", "физиолог", "физиологически", "физиология",
        "физиономия", "физиопрофилактика", "физиопроцедуры", "физиораствор",
        "физиотерапевт", "физкультура", "физкультминутка", "физкультура",
        "физмат", "физматшкола", "физподготовка", "физраствор", "физрук",
        "фиксатор", "фиксирование", "филирование", "филогенез", "филогенетика",
        "филология", "философ", "философия", "фильм", "фильмопроизводство",
        "фильмопрокат", "фильтр", "финалист", "финаль", "финансирование",
        "финансы", "фингал", "финик", "финиш", "финляндия", "фирма", "фирменный",
        "фискал", "фисташка", "фитнес", "фитнесцентр", "фитогормоны", "фитозал",
        "фитол", "фитотерапия", "фиточай", "фитошампунь", "фитоэкстракт",
        "фитоэстрогены", "фитюлечка", "фишка", "фитнес-команда", "фитнес-программа",
        "фитнес-тренер", "физико-математический", "физико-механический",
        "физико-технический", "физико-химический", "физиоактивный", "физиократ",
        "физиолог"
      ],
      keysSubtest1KZ: [
        "бала", "балық", "бақбақ", "бақша", "балмұздақ", "балақай", "бақыт", "бақа", "барабан",
        "баспалдақ", "баспа", "бақша", "баспана", "бағбан", "бақылау", "бақылаушы", "бас", "бармақ",
        "бастық", "батпақ", "балабақша", "балбұлақ", "балғын", "бар", "басты", "барша", "базар",
        "батыс", "бағым", "бағжан", "балапан", "басбармақ", "бақай", "бармақ", "бантик", "бал",
        "бас", "балшық", "батпақ", "балта", "балға", "бағдаршам", "бажа", "бауыр", "бата", "байрақ",
        "батыл", "бақытты", "бастау", "басқару", "бешбармақ", "банан", "бауырсақ", "бауыр",
        "балапан", "батпырауық", "баклажан", "баракат", "барқыт", "балауса", "бақанас", "балқаш",
        "баурай", "байлық", "батыр", "бабалар", "бауырластар", "баға", "бай", "бальзам", "бағдат",
        "бағлан", "база", "баланс", "балерина", "бабажан", "байжан", "байтақ", "бақыт", "балақай",
        "бангладеш", "балгария", "бадам", "балқурай", "балдыр", "бактерия", "бағыт", "баған", "база",
        "бастау", "балуан", "бағдарлама", "басқарма", "баспахана", "базарлық", "бақташы", "банан",
        "бағбан", "балқарағай", "балауса"
      ],
      keysSubtest2: [
        "авва", "автоподстава", "агава", "айва", "альмавива", "альтернатива",
        "антиква", "билингва", "битва", "братва", "бритва", "брюква", "буква",
        "вдова", "вульва", "глава", "голова", "госсредства", "грива", "два",
        "дезсредства", "держава", "детва", "дива", "директива", "дресва", "дрова",
        "дряква", "дубрава", "едва", "ендова", "жатва", "жертва", "жратва",
        "забава", "застава", "издетства", "инвектива", "инициатива", "интерлингва",
        "канва", "кассава", "кваква", "клюква", "трава", "клятва", "контроктава",
        "конъюнктива", "коричнева", "корова", "королева", "косхалва", "кошева",
        "крапива", "средства", "кружева", "кряква", "купава", "лава", "легислатива",
        "лексредства", "листва", "лихва", "ловитва", "локва", "лягва", "мальва",
        "меньшинства", "электробритва", "мойва", "молва", "молитва", "мольва",
        "мурава", "нажива", "нацменьшинства", "нова", "облава", "обнова", "однова",
        "октава", "олива", "оправа", "орава", "основа", "отава", "отрава",
        "оттудова", "паства", "пахлава", "переправа", "перспектива", "песева",
        "плотва", "погранзастава", "подкова", "подлива", "подоснова", "подпочва",
        "подстава", "пожива", "полуслова", "получувства", "полцарства", "почва",
        "приправа", "расправа", "сверхдержава", "слава", "слева", "слива", "снова",
        "сова", "сперва", "спецсредства"
      ],
      keysSubtest2KZ: [
        "бақай", "құрылтай", "сұрай", "нұрай", "қарай", "сипаттай", "балақай", "алақай", "сабақтай",
        "саралай", "құлпынай", "жанай", "адырнай", "қараторғай", "жинақтай", "жаурай", "қалықтай",
        "құлдырай", "жағалай", "әдеміай", "көркемай", "құралай", "бозторғай", "баурай", "бағалай",
        "талдай", "қарабай", "сарыбай", "орай", "жақындай", "санай", "жинай", "бидай", "силай",
        "бай", "сай", "торғай", "торай", "тай", "қаратай", "жазалай", "қарадай", "солай", "құдай",
        "ондай", "алмай", "қалай", "қарай", "шыдай", "тоқтай", "жағдай", "қандай", "сондай", "шықпай",
        "таппай", "қарғай", "болмай", "осылай", "мұндай", "ешқандай", "тоқтамай", "шығармай",
        "байқамай", "минуттай", "араласпай", "ұйықтамай", "айтқандай", "өмірай", "осындай", "олай",
        "оңай", "қай", "ай", "нұрымай", "сарай", "осындай", "айтқандай", "ешқандай", "жағдай",
        "қандай", "сондай", "мұндай", "тұрсынай", "сағынай", "ағыбай", "дударай", "қалақай",
        "сырнай", "тассай", "сағынбай", "ойланбай", "қызықпай", "ғұмырай", "ыбырай", "сарай",
        "шырай", "арай", "найзағай", "толғанай", "жарқынай"
      ]
      ,
      inputSubtest1: '',
      inputSubtest2: '',
      wordsSubtest1 : [],
      wordsSubtest2 : [],
      matchingWordsSubtest1: [],
      matchingWordsSubtest2: [],
      currentSubtest: 1,
      timerNumber: 150,
      interpretationResult: {
        high: {
          ru : "Высокий уровень креативности («признаки одаренности»).<br>Признаки:<br>- Отличное воображение: Ты легко представляешь нестандартные образы и идеи. Твое воображение работает активно и ярко, позволяя создавать уникальные концепции и решения.<br>- Способность думать быстро: Ты можешь быстро адаптироваться к изменениям и находить решения в неожиданных ситуациях.<br>- Творческое и оригинальное мышление: Твои идеи часто выходят за рамки стандартных решений и норм. Ты способен находить новые подходы к решению задач.<br>- Разнообразие идей: Ты можешь предложить множество вариантов и идей, которые различаются по стилю и подходу. Рекомендации:<br>- Развивай свои идеи: Постоянно ищи новые возможности для применения своей креативности. Участвуй в проектах и задачах, которые требуют нестандартного подхода.<br>- Общайся с творческими людьми: Сотрудничай и обсуждай свои идеи с другими креативными личностями. Это поможет тебе расширить горизонты и получить новые вдохновения.<br>- Продолжай обучение: Участвуй в курсах и тренингах, которые помогают развивать креативность, например, по креативному мышлению, инновациям и дизайну.",
          kz : "Креативтіліктің жоғары деңгейі («дарындылық белгілері»).<br>Белгілері:<br>- Ұшқыр қиял: Сіз стандартты емес бейнелер мен идеяларды оңай елестете аласыз. Сіздің қиялыңыз белсенді және жарқын жұмыс істейді, бұл сізге бірегей тұжырымдамалар мен шешімдер жасауға мүмкіндік береді.<br>- Тез ойлау қабілеті: сіз өзгерістерге тез бейімделе аласыз және күтпеген жағдайларда шешім таба аласыз.<br>- Шығармашылық және ерекше ойлау: сіздің идеяларыңыз көбінесе стандартты шешімдер мен нормалардан асып түседі. Сіз проблемаларды шешудің жаңа тәсілдерін таба аласыз.<br>- Идеялардың әртүрлілігі: сіз стиль мен тәсілде ерекшеленетін көптеген нұсқалар мен идеяларды ұсына аласыз.<br>Ұсыныстар:<br>- Өз идеяларыңызды дамытыңыз: шығармашылықты қолданудың жаңа мүмкіндіктерін үнемі іздеңіз. Стандартты емес тәсілді қажет ететін жобалар мен міндеттерге қатысыңыз.<br>- Шығармашылық адамдармен байланыс: өз идеяларыңызды басқа шығармашылық тұлғалармен бірлесіп, талқылаңыз. Бұл сізге көкжиектерді кеңейтуге және жаңа шабыт алуға көмектеседі.<br>- Оқуды жалғастырыңыз: шығармашылық ойлау, инновация және дизайн сияқты шығармашылықты дамытуға көмектесетін курстар мен тренингтерге қатысыңыз.",
        },
        middle: {
          ru: "Средний уровень креативности.<br>Признаки:<br>- Хорошее воображение: Ты способен создавать идеи и представления, но иногда тебе может не хватать глубины или новизны.<br>- Достаточная скорость мышления: Ты можешь быстро адаптироваться к изменениям, но иногда твое мышление может замедляться.<br>- Иногда оригинальные идеи: Твои идеи бывают оригинальными, но это происходит не всегда и может требовать дополнительных усилий.<br>- Некоторое разнообразие идей: Ты можешь предлагать разнообразные идеи, но они могут быть менее креативными по сравнению с идеями людей с высоким уровнем креативности.<br>Рекомендации:<br>- Посещай психологические занятия: Занятия, которые сосредоточены на развитии креативности и креативного мышления, помогут тебе раскрыть свой потенциал.<br>- Работай над улучшением воображения: Проводя регулярные упражнения для развития воображения, например, медитации, чтение книг по креативности, можно улучшить свои креативные способности.<br>- Изучай примеры инновационного мышления: Ознакомься с работами и подходами известных креативных личностей, чтобы вдохновляться и развивать свои собственные идеи.",
          kz: "Креативтіліктің орташа деңгейі<br>Белгілері:<br>- Жақсы қиял: Сіз идеялар мен түсініктер жасай аласыз, бірақ кейде сізге тереңдік немесе жаңалық жетіспеуі мүмкін.<br>- Ойлаудың жеткілікті жылдамдығы: сіз өзгерістерге тез бейімделе аласыз, бірақ кейде сіздің ойыңыз баяулауы мүмкін.<br>- Кейде болатын ерекше идеялар: сіздің идеяларыңыз ерекше, бірақ бұл әрдайым бола бермейді және қосымша күш жұмсауды қажет етуі мүмкін.<br>- Идеялардың әртүрлілігі: сіз әртүрлі идеяларды ұсына аласыз, бірақ олар шығармашылық деңгейі жоғары адамдардың идеяларымен салыстырғанда аз шығармашылық болуы мүмкін.<br>Ұсыныстар:<br>- Психологиялық сабақтарға қатысыңыз: шығармашылық пен шығармашылық ойлауды дамытуға бағытталған сабақтар сіздің әлеуетіңізді ашуға көмектеседі.<br>- Қиялды жақсарту үшін жұмыс жасаңыз: қиялды дамыту үшін үнемі жаттығулар жасау, мысалы, медитация, Шығармашылық туралы кітап оқу, шығармашылық қабілеттеріңізді жақсартуға болады.<br>- Инновациялық ойлаудың мысалдарын зерттеңіз: өз идеяларыңызды шабыттандыру және дамыту үшін танымал шығармашылық тұлғалардың жұмыстары мен тәсілдерімен танысыңыз.",
        },
        low: {
          ru: "Креативность «в зоне ближайшего развития».<br>Признаки:<br>- Хорошее воображение: У тебя есть способность к созданию образов и идей, но тебе может не хватать скорости или оригинальности мышления.<br>- Медленное или менее оригинальное мышление: Твое мышление может быть менее гибким, а идеи – менее инновационными.<br>- Трудности с созданием оригинальных историй: Возможно, тебе сложно придумывать уникальные сюжеты и концепции, что может затруднять творческую деятельность.<br>Рекомендации:<br>- Посещай психологические занятия: Специализированные тренинги и занятия помогут тебе развить креативные навыки и научат методам улучшения креативного мышления.<br>- Развивай навыки самостоятельного мышления: Проводя упражнения, направленные на развитие оригинального мышления и творчества, такие как написание собственных рассказов или создание уникальных проектов, можно повысить уровень креативности.<br>- Используй креативные техники: Пробуй методы, которые помогают стимулировать креативность, такие как «мозговой штурм», «карты разума» или «техника случайных слов».",
          kz: "Креативтілік «жақын даму аймағы»<br>Белгілері:<br>- Жақсы қиял: сізде бейнелер мен идеялар жасау мүмкіндігі бар, бірақ сізде ойлау жылдамдығы немесе өзіндік ерекшелігі болмауы мүмкін.<br>- Ерекше ойлаудың аз немесе баяу болуы: сіздің ойлауыңыздың икемділігі төмен болуы мүмкін, ал идеялардың жаңашылдығы аз болуы мүмкін.<br>- Ерекше қиялдағы ойды жасаудағы қиындықтар: шығармашылық әрекетті қиындататын бірегей сюжеттер мен тұжырымдамаларды ойлап табу қиын болуы мүмкін.<br>Ұсыныстар:<br>- Психологиялық сабақтарға қатысыңыз: мамандандырылған тренингтер мен сабақтар сізге шығармашылық дағдыларды дамытуға көмектеседі және шығармашылық ойлауды жақсарту әдістерін үйретеді.<br>- Өз бетіңізше ойлау дағдыларын дамытыңыз: өз әңгімелеріңізді жазу немесе бірегей жобалар жасау сияқты өзіндік ойлау мен шығармашылықты дамытуға бағытталған жаттығулар жасай отырып, шығармашылық деңгейін арттыруға болады.<br>- Шығармашылық әдістерді қолданыңыз: «миға шабуыл», «ақыл карталары» немесе «кездейсоқ сөз техникасы» сияқты шығармашылықты ынталандыруға көмектесетін әдістерді қолданып көріңіз."
        },
      }
      // interpretationResult: {
      //   high: this.$t('creativity-15-17.interpretation-high'),
      //   middle: this.$t('creativity-15-17.interpretation-middle'),
      //   low: this.$t('creativity-15-17.interpretation-low'),
      // }
    }
  },
  methods: {
    countMatches1() {
      if (this.$i18n.locale == 'ru') {
        this.matchingWordsSubtest1 = this.wordsSubtest1.filter(word => this.keysSubtest1.includes(word));
      } else {
        this.matchingWordsSubtest1 = this.wordsSubtest1.filter(word => this.keysSubtest1KZ.includes(word));
      }

    },
    countMatches2() {
      if (this.$i18n.locale == 'ru') {
        this.matchingWordsSubtest2 = this.wordsSubtest2.filter(word => this.keysSubtest2.includes(word));
      } else {
        this.matchingWordsSubtest2 = this.wordsSubtest2.filter(word => this.keysSubtest2KZ.includes(word));
      }

    },
    handleInput() {
      const rawWords = this.inputSubtest1
          .toLowerCase()
          .split(/[\s,;]+/)
          .filter(word => word);

      this.wordsSubtest1 = [...new Set(rawWords)];

      this.countMatches1()
    },
    handleInput2() {
      const rawWords = this.inputSubtest2
          .toLowerCase()
          .split(/[\s,;]+/)
          .filter(word => word);

      this.wordsSubtest2 = [...new Set(rawWords)];

      this.countMatches2()
    },
    nextSubtest(timer) {

      if (timer) {

        this.currentSubtest = 2
        localStorage.setItem('currentSubtest', "2")
        this.startTimer(this.timerNumber)

        return
      }

      this.handleInput()

      if (!this.wordsSubtest1.length) {

        return Vue.toastr({
          message: this.$t('error-title'),
          description: 'Заполните поле',
          type: 'error'
        })
      } else {
        clearInterval(this.timerInterval);
        this.currentSubtest = 2
        localStorage.setItem('currentSubtest', "2")
        this.startTimer(this.timerNumber)
      }
    },
    openModal() {
      this.$bvModal.show('exit-modal');
    },
    async sendCreativitySubtest2Results(timer) {

      this.handleInput2()

      if (!timer && !this.wordsSubtest2.length) {

        return Vue.toastr({
          message: this.$t('error-title'),
          description: 'Заполните поле',
          type: 'error'
        })
      }

      const creativitySubtest2Data = {
        answers: {inputSubtest1: this.inputSubtest1, inputSubtest2: this.inputSubtest2,},
        score: this.matchingWordsSubtest1.length + this.matchingWordsSubtest2.length,
        interpret: this.interpretScore(this.matchingWordsSubtest1.length + this.matchingWordsSubtest2.length),
        addInfo: {
          matchingWordsSubtest1Array: this.matchingWordsSubtest1,
          matchingWordsSubtest1: this.matchingWordsSubtest1.length,
          matchingWordsSubtest2Array: this.matchingWordsSubtest2,
          matchingWordsSubtest2: this.matchingWordsSubtest2.length
        },
      }

      let params = JSON.parse(localStorage.getItem('quiz-params-15-17'))
      const quizToken = localStorage.getItem('quiz-token')

      params.answer_id = {...params.answer_id, creativitySubtest2Data}
      localStorage.setItem('quiz-params-15-17', JSON.stringify(params))

      console.log('params', params)

      const response = await this.$http.post(API_ROOT + '/api/user-answer/' + quizToken, params)

      if (response.body.status == 'success') {

        localStorage.setItem('current-test', 'composing-image2')

        Vue.toastr({
          message: this.$t('successful'),
          description: this.$t('saved-successfully'),
          type: 'success'
        })
      } else {
        Vue.toastr({
          message: this.$t('error-title'),
          description: this.$t('error-saving'),
          type: 'error'
        })
      }

      setTimeout(() => {
        this.$router.push({ path: '/composing-image2' })
      }, 1500)

    },
    interpretScore(score) {
      if (score >= 30) {
        return this.interpretationResult.high;
      } else if (score >= 15) {
        return this.interpretationResult.middle;
      } else {
        return this.interpretationResult.low;
      }
    },
    startTimer(duration) {
      let timer = duration, minutes, seconds;
      this.timerInterval = setInterval(() => {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        this.countdown = minutes + ":" + seconds;

        let savedTimer = (parseInt(minutes) * 60) + parseInt(seconds);
        localStorage.setItem('timerCreativitySubtest2', savedTimer);

        if (--timer < 0) {
          if (this.currentSubtest == 1) {

            setTimeout(() => {
              this.nextSubtest(true)
            }, 800)

          } else {
            this.sendCreativitySubtest2Results(true)
          }

          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    redirectIfEnded() {
      const quizToken = localStorage.getItem('quiz-token');
      const userQuizId = localStorage.getItem('user_quiz_id');
      const quizEnded = localStorage.getItem('quiz-ended');

      if (quizEnded && quizEnded === `${userQuizId}-${quizToken}`) {
        window.location.href = `${window.QABILET_ROOT}/test-results-15-17/${userQuizId}/${quizToken}`
      }
    },
  },
  mounted() {
    this.redirectIfEnded();

    if (localStorage.getItem('timerCreativitySubtest2')) {
      this.startTimer(localStorage.getItem('timerCreativitySubtest2'))
    } else {
      this.startTimer(this.timerNumber)
    }

    if (localStorage.getItem('currentSubtest')) {
      this.currentSubtest = (localStorage.getItem('currentSubtest'))
    } else {
      localStorage.setItem('currentSubtest', "1")
    }

    if (localStorage.getItem('current-test')) {
      this.$router.push({name: localStorage.getItem('current-test')});
    }


    const testLang = localStorage.getItem('test_lang');
    if (testLang) this.$i18n.locale = testLang;
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  }
}
</script>

<style>
.select-custom-collaboration {
  width: 240px !important;
}

.collaboration-desc {
  margin: 20px 0;
}

.collaboration-options {
  cursor: pointer;
  position: relative;
}

.el-select-group__title {
  position: relative;
}

.el-select-group__title::after {
  position: absolute;
  right: 10px;
  top: 2px;
  content: '▼';
}


</style>
